import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { resetState, updateState } from "../redux/commonSlice";
import { eventsList } from "../services/api";
import useSnackMessage from "./useSnackMessage";

export default (enableEventsRequest = true) => {
  // const commonReducer = useSelector((state) => state.root.commonReducer);

  //Get approver dropdown array from Server
  //const eventListLabel = 'value';
  const dispatch = useDispatch();
  const [showSnackbar] = useSnackMessage();
  const [enableEventsList, setEnableEventsList] = useState(enableEventsRequest);
  // const [approverError, setApproverError] = useState("Please select approver");
  const {
    data: eventsListData,
    isLoading: eventsListLoading,
    error: eventListError,
    refetch: refetchEventsList,
  } = useQuery(
    [
      `eventsList${window.localStorage.getItem("token")}`,
      window.localStorage.getItem("token"),
    ],
    () => eventsList(),
    { enabled: enableEventsList, retry: false }
  );
  useEffect(() => {
    if (eventsListData) {
      const events = eventsListData?.data?.data;
      setEnableEventsList(false);
      // dispatch(
      //   updateState({
      //     completed_events: events.finished_events,
      //     production_events: [...events.production_events.ongoing_events, ...events.production_events.upcoming_events ],
      //     ongoing_events: events.production_events.ongoing_events,
      //     upcoming_events: events.production_events.upcoming_events
      //   })
      // );
    }
  }, [eventsListData]);

  useEffect(() => {
    if(eventListError) {
      const errorObject = eventListError?.response?.data;
      showSnackbar(errorObject);
      // dispatch(setSnackbar({ ...setSnackMessageType(responseObject) }));
      // if (eventListError?.response?.data?.http_code == 401) {
      //   window.localStorage.removeItem("token");
      //   dispatch(resetState());
      // }
    }
   
  }, [eventListError]);

  // const selectedeventList = (id) => {
  //     if (eventList.length > 0 && eventList.find((item)=> item.id == id) ) {
  //        // setApproverError("");
  //         return eventList.find((item)=> item.id == id)
  //     } else {
  //         return {}
  //     }
  // };

  return [refetchEventsList];
};
